const API_BASE = '/api';
async function apiFetch(path, options) {
    const res = await fetch(`${API_BASE}${path}`, {
        credentials: 'include',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({ error: res.statusText }));
        throw new Error(body.error || `HTTP ${res.status}`);
    }
    return res.json();
}
export const lessonApi = {
    getModules() {
        return apiFetch('/lessons');
    },
    getLesson(id) {
        return apiFetch(`/lessons/${id}`);
    },
    checkAnswer(id, sql) {
        return apiFetch(`/lessons/${id}/check`, {
            method: 'POST',
            body: JSON.stringify({ sql }),
        });
    },
    getHint(id, hintsRevealed) {
        return apiFetch(`/lessons/${id}/hint`, {
            method: 'POST',
            body: JSON.stringify({ hintsRevealed }),
        });
    },
    runQuery(id, sql) {
        return apiFetch(`/lessons/${id}/run`, {
            method: 'POST',
            body: JSON.stringify({ sql }),
        });
    },
    runExample(id) {
        return apiFetch(`/lessons/${id}/example`, {
            method: 'POST',
        });
    },
};
export const leaderboardApi = {
    getLeaderboard(limit = 20, offset = 0) {
        return apiFetch(`/leaderboard?limit=${limit}&offset=${offset}`);
    },
};
export const progressApi = {
    getSummary() {
        return apiFetch('/progress');
    },
    completeLesson(lessonId, attempts, hintsUsed, timeSeconds) {
        return apiFetch('/progress/complete', {
            method: 'POST',
            body: JSON.stringify({ lessonId, attempts, hintsUsed, timeSeconds }),
        });
    },
    getAchievements() {
        return apiFetch('/progress/achievements');
    },
    getStreak() {
        return apiFetch('/progress/streak');
    },
};
export const shareApi = {
    shareProfile() {
        return apiFetch('/share', {
            method: 'POST',
            body: JSON.stringify({ shareType: 'profile' }),
        });
    },
    shareAchievement(achievementId) {
        return apiFetch('/share', {
            method: 'POST',
            body: JSON.stringify({ shareType: 'achievement', context: achievementId }),
        });
    },
};
export const adminApi = {
    getOverview() {
        return apiFetch('/admin/overview');
    },
    getLessons() {
        return apiFetch('/admin/lessons');
    },
    getAchievements() {
        return apiFetch('/admin/achievements');
    },
    getXpDistribution() {
        return apiFetch('/admin/xp-distribution');
    },
    getGrowth(period = 'day') {
        return apiFetch(`/admin/growth?period=${period}`);
    },
};
